export const paymentMethodRefundsSchema = [
  {
    name: "Payment_Method",
    label: "Payment Category",
    textAlign: "start",
    sort: false,
  },
  { name: "value", label: "Value", textAlign: "center" },
  { name: "percentage1", label: "%", textAlign: "start" },
  { name: "count", label: "Count", textAlign: "start" },
  { name: "percentage2", label: "%", textAlign: "start" },
];

export const failedRefundTransactionsDistributionSchema = [
  { name: "reason", label: "Reason", sort: false },
  { name: "value", label: "Value" },
  { name: "percentage1", label: "%" },
  { name: "count", label: "Count" },
  { name: "percentage2", label: "%" },
];
